<template>
  <div style="background:#FDFDFE;">
    <div class="contentbox">
        <div class="logo">
          <!-- <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')"> -->
        </div>
        <div class="backimg"></div>
        <div class="inqtype" >
          <ul>
            <li @click="inqType = 'gr'">
              <a href="javascript:;;" :class="inqType == 'gr' ? 'active' : ''">
                个人会员
              </a>
            
            </li>
            <li @click="inqType = 'dw'">
              <a href="javascript:;;" :class="inqType === 'dw' ? 'active' : ''" >
                单位会员
              </a>
            </li>
            <li @click="inqType = 'ban'">
              <a href="javascript:;;" :class="inqType === 'ban' ? 'active' : ''" >
                备案查询
              </a>
            </li>
          </ul>
        </div>
        <div class="inqBox">
              <div class="leftBox">
               <div class="title">
                      {{ inqType | getTitle }}
                    </div>
                <div v-if="inqType=='gr'">
                  <div class="textbox shoujiios"><input type="text" v-model="cert.name" class="inname" placeholder="请输入姓名"/></div>
                  <div class="textbox bianhaoda"><input type="text" v-model="cert.code" class="incert" placeholder="请输入会员证号"/></div>
                </div>
                <div v-else-if="inqType=='ban'">
                  <div class="textbox shoujiios"><input type="text" v-model="cert.companyname" class="inname" placeholder="请输入企业名称"/></div>
                  <div class="textbox bianhaoda"><input type="text" v-model="cert.code" class="incert" placeholder="请输入备案登记号"/></div>
                  
                  
                </div>
                <div v-else>
                  <div class="textbox shoujiios"><input type="text" v-model="cert.companyname" class="inname" placeholder="请输入企业名称"/></div>
                    <div class="textbox bianhaoda"><input type="text" v-model="cert.code" class="incert" placeholder="请输入会员证号"/></div>
                  
                  
                </div>
                <button @click="submitForm() ">查询</button>
                
              </div>

        </div>
        <div class="memberfile">
                  <div class="filetitle">
                    <h2>附会员申请表格</h2>
                  </div>
                  <div class="filelist">
                    <ul>
                      <li v-for="(file ,index) in applyFiles" :key="index">
                        <router-link v-if="!file.filesrc" :to="`/news/info/${file.plateid}/${file.uuid}`">
                          {{file.title}}
                        </router-link>
                        <a v-else :href="`${IP_TEST}/uploads/${file.filesrc}`" >{{file.title}}</a>
                      </li>
                    </ul>
                  </div>
        </div>
        <div class="recodenum">备案号：{{ recodenum }}</div>
    </div>
  </div>  
</template>
  
<script>
  
  import { getPersonalMember,getCompanyMember,getBeiAn  } from '@/request/index';
  import { getCertTypes,getFindPage ,getArticles} from '@/request/get';
  import { IP_TEST } from '@/config'
  const rate = window.outerWidth / 599;
  export default {
    metaInfo: {
      title: '会员查询',
      meta: [
        {
          name: 'viewport', content:
            `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
        }
      ]
    },
    name: "inquery",
    components: {
  },
  filters: {
    getTitle(value) {
      if (value == 'gr') {
        return '个人会员';
      }
      if (value == 'dw') {
        return '单位会员';
      }
      if (value == 'ban') {
        return '备案查询';
      }
    }
  },
  computed: {
    recodenum() {
      return this.$store.getters.recodenum;
    },
    logopic() {
      return this.$store.getters.logopic;
    }
  },
    data() {
      return {
        occupations: [],
        occupationFlag:false,
        cert: {
          name: "",
          code:"",
          companyname:""
        },
        applyFiles:[],
        selcertname:"",
        gourl:"",
        certTypes:[],
        inqType:'gr',
        IP_TEST
      }
    },
    created(){
     if(this.$route.query&&this.$route.query.inqtype)
      this.inqType = this.$route.query.inqtype;
     this.getCertTypes();
     this.getFindPage();
  
    },
    mounted() {
      var lastTouchEnd = 0;
      document.addEventListener(
        "touchend",
        function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
    },
    methods: {
      async getFindPage() {
        let result = await getFindPage();
        result = result.data || [];
        this.$store.dispatch("SET_PLATES", result)
        let { plates } = this.$store.state;
        let list = plates.filter((item) => '会员附件' == item.name);
        let uuid = list[0].uuid;
        result =  await getArticles(uuid);
        this.applyFiles = result.data ||[];
      },
      goHome() {
        this.$router.push("/");
      },
      handleInq() {
        if (!this.selcertname) {
          this.$message.error("请选择职业名称");
          return;
        }
        for(let i=0;i<this.occupations.length;i++)
        { 
          if(this.occupations[i].certname==this.selcertname)
          {
            this.cert = this.occupations[i];
            break;
          }
        }
        this.$router.push({
          name: "Show",
          query: {
            name: this.cert.name,
            code: this.cert.code,
            certtypename: this.cert.certtypename
          }
        })
      },
      async getCertTypes(){
        let result = await getCertTypes();
        this.certTypes = result.data;
      },
      /**
       *  cname: "单位名称"或姓名,
          ccode: "信用代码"或证件号,
          bzcode: "证书编号"或标准号
      */
      async submitForm() {
        if(this.inqType=='gr')
        {
          if ((this.cert.name == "" && this.cert.code == "")) {
            return;
          }
          let result =await getPersonalMember(this.cert.name,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                name: this.cert.name,
                code: this.cert.code,
                inqType:"gr"
              }
            })
          }else{
            this.$message.error("您输入的会员信息不存在，谨防假冒。");
          }
        }else if(this.inqType=='dw'){
          if ((this.cert.companyname == "" && this.cert.code == "")) {
            return;
          }
          let result =await getCompanyMember(this.cert.companyname,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                companyname: this.cert.companyname,
                code: this.cert.code,
                inqType:"dw"
              }
            })
          }else{
            this.$message.error("您输入的会员信息不存在，谨防假冒。");
          }
        }else{
          if ((this.cert.companyname == "" && this.cert.code == "")) {
            return;
          }
          let result =await getBeiAn(this.cert.companyname,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                companyname: this.cert.companyname,
                code: this.cert.code,
                inqType:"ban"
              }
            })
          }else{
            this.$message.error("您输入的备案信息不存在，谨防假冒。");
          }
        }
       
      }
    }
  };
</script>
<style scoped >
  
  .logo{
      text-align: left;
      position: relative;
      margin-top: 13.867vw;
  }
  .backimg{
    position: relative;
    width: 94vw;
    margin-top: 8.267vw;
  height: 35.6vw;
  background-image: url(/static/img/img/bnen.png);
  background-size:cover ;
  }
  .contentbox{
    min-height: 100%;
  }
  .contentbox {
    position: relative;
    overflow: hidden;
    width: 94vw;
    margin:auto;
min-height: 100%;
  }
  .inqBox{
      position: relative;
      margin-top:5.867vw;
    width: 94vw;
height: 107.067vw;
background: #FFFFFF;
box-shadow: 0px 1.6vw 6.8vw 0px rgba(68,98,207,0.19);
opacity: 0.9;
border-radius: 2.667vw;
  }
  .leftBox .title{
    position: relative;
    margin: 13.333vw 0 9.733vw;
height: 4.8vw;
font-size: 5.067vw;
font-family: PingFang SC;
font-weight: bold;
color: #252626;
line-height: 4.8vw;
text-align:center;
  }
.leftBox input {
    width: 64.667vw;
height: 11.067vw;
background: #F2F4F9;
border-radius: 0.667vw;
    font-size: 3.733vw;
font-family: PingFang SC;
font-weight: 400;
color: 333333;
line-height: 11.067vw;
}
.leftBox input::placeholder{
  color: #9BA1A8;
}
.textbox{
  padding-left: 12vw;
  margin: 0 auto;
  position: relative;
    margin-top:6.933vw ;
   width: 64.667vw;
height: 11.067vw;
background: #F2F4F9;

}
.leftBox .shoujiios{
  background-image: url(/static/img/img/shoujiios.png);
  background-repeat: no-repeat;
  background-size: 4.267vw 4.133vw;
border-radius: 0.667vw;
background-position: 3.067vw center;
}
.leftBox .bianhaoda{
  background-image: url(/static/img/img/shegnn.png);
  background-repeat: no-repeat;
  background-size: 5.733vw 4.667vw;
border-radius: 0.667vw;
background-position: 2vw center;
}
.leftBox .da{
  background-image: url(/static/img/img/da.png);
  background-repeat: no-repeat;
  background-size: 3.867vw 4.533vw;
border-radius: 0.667vw;
background-position: 3.067vw center;
}
.intype::before,.textbox::before{
    content:'';
    position: absolute;
    top:3.467vw;
    left: 9.6vw;
    width: 0.267vw;
height: 4.133vw;
background: #E3E6EF;
z-index: 1;
   }

.leftBox button {
  margin-top:9.467vw;
  margin-left: 8.667vw;
  width: 76.667vw;
height: 11.067vw;
background: #2F8EEC;
border-radius: 0.667vw;
line-height: 11.067vw;
font-size: 4.267vw;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
}
  .leftBox{
    width:94vw;
   height:100%;
   overflow: hidden;
  }
  .intype >>>.el-input__inner{
    background-color:transparent;
    border:none;
    height: 46px;
      line-height: 46px;
      padding:0px;
      font-size: 16px;
      color: #FFFFFF;
  }
  .kouniu2{
    position: relative;
      top: -67px;
      left: 57px;
      width: 52px;
  }
  .inqtype ul li{
    display: inline-block;
    text-align: center;
  }
  .inqtype{
    position: relative;
    margin-left: 24.267vw;
    margin-top:6.8vw;
    width: 68.9vw;
height: 7.467vw;
border: 0.133vw solid #E0E3E9;
  }
  .inqtype ul li a{
    padding: 0 4vw;
height: 7.467vw;
    display: inline-block;
    color: #717375;
    font-size: 3.733vw;
    line-height: 7.467vw;
    text-align: center;
  }
  .inqtype ul li .active{
background: #2F8EEC;

color: #FFFFFF;
  }
  .memberfile{
    position: relative;
    margin-top:8.8vw;
    height: 54.2vw;
  }

  .memberfile .filetitle h2 {
height: 38px;
font-size: 30px;
padding-left:56px;
font-family: PingFang SC;
font-weight: 400;
color: #333333;
line-height: 38px;
background-image: url(/static/img/img/fuajin.png);
background-repeat: no-repeat;
background-size: 34px 38px;
background-position: left center;
  }
  .memberfile .filelist a{
    margin-top:6vw;
    margin-bottom: 6vw;
    display: block;
min-height: 4.267vw;
font-size: 3.467vw;
font-family: PingFang SC;
font-weight: 400;
color: #2F8EEC;
line-height: 3.467vw;
border-bottom: 1px solid #2F8EEC;
  }
  .rightBox img{
    position: relative;
    top: 88px;
    left: 23px;
  }
  .recodenum{
    position: relative;
    margin-bottom: 6.4vw;
    width: 100%;
    height: 1.867vw;
    font-size: 1.867vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #AEB8C3;
    line-height: 1.867vw;
    text-align: center;
  }
  .leftBox .title::after{
    position: absolute;
    content:'';
     left:50%;
  transform: translateX(-50%);
  bottom:-4.8vw;
  width: 6.133vw;
height: 1.333vw;
background: #2F8EEC;
border-radius: 0.667vw;
  }
</style>
  